import { CommonModule } from "@angular/common";
import { Component, input, ChangeDetectionStrategy } from "@angular/core";
import { MatCard } from "@angular/material/card";

@Component({
  selector: "loren-page-content",
  imports: [CommonModule, MatCard],
  templateUrl: "./loren-page-content.component.html",
  styleUrl: "./loren-page-content.component.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    '[class.flush]': 'flush()',
  },
})
export class LorenPageContentComponent {
  title = input<string>();
  flush = input<boolean>();
  unrounded = input<boolean>();
}
